import { Component, OnInit } from '@angular/core';

import * as echarts from 'echarts';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { debounceTime, forkJoin, Observable, of, Subject, Subscription, switchMap, tap } from 'rxjs';
import { DatePipe } from '@angular/common';
import { createChartSingle, formatYear } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';


interface Month {
  key: number;
  name: string;
}
@Component({
  selector: 'app-attrition-salary-leave-wise',
  templateUrl: './attrition-salary-leave-wise.component.html',
  styleUrls: ['./attrition-salary-leave-wise.component.scss'],
})
export class AttritionSalaryLeaveWiseComponent implements OnInit {
  isUserEmployee: boolean = false;
  graphType: string = 'bar';  // Default chart type


  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  setupGradeBrand: any;
  setUpyearRange: any;
  loggedInUserEmpCode: any | null;
  buttonColorName: any | null;
  subModuleButtonColor: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  loggedInUserCompanyID: any;
  selectedYearForCompetency: any = null;
  selectedYear: any = null;
  fromYear: any;
  toYear: any;
  arrAllMonths: any = [];
  selectedMonth: any;
  variableFrequency: any;
  frequencies: string[] = ["Monthly", "Quaterly", "Semi-Annually", "Annually"];
  setupFrequency: any = null;
  filteredFrequencies: string[] = [];
  filteredFrequenciesSummary: string[] = [];
  filteredFrequenciesVariable: any;
  frequencyName!: string;
  setupMonths: any = [];
  frequencyPeriod: any = null;
  isVPSetupDone: boolean = false;
  isVPInputSetupNotDone: boolean = false;
  cutOffDays: number | null = null;
  GetOverallIncrementBudgetGridData: any = [];
  fromMonth: any = null;
  toMonth: any = null;
  cutOffDate: any;
  previousOverallVPBudgetGrid: any = [];
  selectedMonths: string[] = [];
  cutOffDateForVariablepay!: string;
  getMonthsToVariablePay: string[] = [];
  allMonths: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  toMonthsVariablePay: string[] = [];
  cutOffDaysChange: Subject<string> = new Subject<string>();

  selectedMonthName: any;
  previousMonthsCountAprilMarch: any;
  previousMonthsCountJanDec: any;
  arrUserIds: any = [];
  intHODempCode: any;
  arrHODByExitedUserList: any = [];
  arrExitedUserIds: any = [];
  arrHODByUserList: any = [];
  loggedInUserName: any
  constructor(private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config,
    public sharedService: SharedService, private datePipe: DatePipe, private PdfDownload: PdfDownloadService) { }

  ngOnInit() {

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.intHODempCode = sessionStorage.getItem('empCode');


    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;

    // console.log("+++++++++++++++++",this.loggedInCompanyReviewCycle);


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
    this.cutOffDaysChange
      .pipe(debounceTime(300)) // Debounce for 300ms, adjust as needed
      .subscribe(day => this.processCutoffDateInput(day));
  }

  switchGraphType(type: string) {
    this.graphType = type;
    // this.loadGraph();
  }

  downloadGraph() {

  }


  // hi

  tableData: { lowerEnd: string; higherEnd: string }[] = [];
  showInputs: boolean = false;
  maxRange: number | any = null;
  scoreRange: number | any = null;
  errMsgMaxRange: boolean = false;
  showMaxRangeError: boolean = false;
  errorMessage: string = '';
  restrictToEditSetup: boolean = false;
  isInValidMaxRange: boolean = false;

  isLastMaxRange100(): boolean {
    if (this.tableData.length === 0) {
      return false;
    }
    return Number(this.tableData[this.tableData.length - 1].higherEnd) === 100;
  }

  toggleInputs() {
    if (this.showInputs) {
      this.saveData();
    } else {
      if (this.isLastMaxRange100()) {
        alert('Max Range of 100 already reached. You cannot add more ranges.');
        return;
      }
      this.scoreRange = this.tableData.length > 0 ? Number(this.tableData[this.tableData.length - 1].higherEnd) : 0;
    }
    this.showInputs = !this.showInputs;
  }

  saveData() {
    this.showMaxRangeError = false;
    if (this.maxRange == null) {
      this.errMsgMaxRange = true;
      return;
    }
    this.errMsgMaxRange = false;
    const maxRangeNum = Number(this.maxRange);

    if (maxRangeNum > 100) {
      alert('Validation failed: max range cannot exceed 100.');
      return;
    }
    if (this.isLastMaxRange100() && maxRangeNum !== 100) {
      alert('Validation failed: The maximum range must be 100 to proceed.');
      return;
    }
    this.tableData.push({
      lowerEnd: this.scoreRange!.toString(),
      higherEnd: this.maxRange.toString()
    });
    this.resetFormFields();
    this.showInputs = false;
  }

  onMaxRangeChange(data: { maxRange: number | string; minRange: number }): void {
    const maxRange = typeof data.maxRange === 'string' ? Number(data.maxRange) : data.maxRange;
    if (isNaN(maxRange) || maxRange <= data.minRange || maxRange <= 0) {
      this.isInValidMaxRange = true;
      this.maxRange = null;
    } else {
      this.isInValidMaxRange = false;
    }
  }

  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'e' || event.key === '+') {
      event.preventDefault();
    }
  }

  removeInputs() {
    this.showInputs = false;
    this.resetFormFields();
  }

  resetFormFields() {
    this.scoreRange = null;
    this.maxRange = null;
    this.isInValidMaxRange = false;
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);



    });
  }

  selectedYearForCompetency1: any;
  selectedYearForCompetency2: any;
  selectedYearForCompetency3: any;
  selectedYearForCompetency4: any;
  selectedYearForCompetency5: any;
  selectedYearForCompetency6: any;

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency1 = selectedYearObj?.year;
      this.selectedYearForCompetency2 = selectedYearObj?.year;
      this.selectedYearForCompetency3 = selectedYearObj?.year;
      this.selectedYearForCompetency4 = selectedYearObj?.year;
      this.selectedYearForCompetency5 = selectedYearObj?.year;
      this.selectedYearForCompetency6 = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      if (this.intHODempCode != 'null') {
        this.fetchHODByUserList('');
      } else {
        this.getMonths(this.fromYear, this.toYear, 'first');
        this.getMonths(this.fromYear, this.toYear, 'second');
        this.getMonths(this.fromYear, this.toYear, 'three');
        this.getMonths(this.fromYear, this.toYear, 'four');
        this.getMonths(this.fromYear, this.toYear, 'five');
        this.getMonths(this.fromYear, this.toYear, 'six');
      }
    }
  }
  onYearChange(year: any, graphNo: any) {
    this.taskFromDate = null;
    this.taskToDate = null;


    if (graphNo == 'first') {
      this.selectedYearForCompetency1 = year;
    }
    if (graphNo == 'second') {
      this.selectedYearForCompetency2 = year;
    }
    if (graphNo == 'three') {
      this.selectedYearForCompetency3 = year;
    }
    if (graphNo == 'four') {
      this.selectedYearForCompetency4 = year;
    }
    else if (graphNo == 'five') {
      this.selectedYearForCompetency5 = year;
    }
    else if (graphNo == 'six') {
      this.selectedYearForCompetency6 = year;
    }
    else { }
    if (this.intHODempCode != 'null') {
      this.fetchHODByUserList(graphNo);
    } else {
      this.getMonths(this.fromYear, this.toYear, graphNo);
    }
  }

  fiscalYearMonthsAprilMarch = [
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
  ];

  fiscalYearMonthsJanDec = [
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
  ];



  selectedMonth1: any;
  selectedMonth2: any;
  selectedMonth3: any;
  selectedMonth4: any;
  selectedMonth5: any;
  selectedMonth6: any;


  selectedMonthName1: any;
  selectedMonthName2: any;
  selectedMonthName3: any;
  selectedMonthName4: any;
  selectedMonthName5: any;
  selectedMonthName6: any;


  getMonths(fromYear: any, toYear: any, graphNo: any) {
    this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec') ? this.fiscalYearMonthsJanDec : this.fiscalYearMonthsAprilMarch;
    console.log(this.arrAllMonths);
    const currentMonth = new Date().getMonth() + 1;
    switch (graphNo) {
      case 'first':
        this.selectedMonth1 = currentMonth;
        break;
      case 'second':
        this.selectedMonth2 = currentMonth;
        break;
      case 'three':
        this.selectedMonth3 = currentMonth;
        break;
      case 'four':
        this.selectedMonth4 = currentMonth;
        break;
      case 'five':
        this.selectedMonth5 = currentMonth;
        break;
      case 'six':
        this.selectedMonth6 = currentMonth;
        break;
      default:
        this.selectedMonth1 = currentMonth;
    }

    console.log("selectedMonth1", this.selectedMonth1);


    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth1
    );
    this.selectedMonthName1 = selectedMonthObj ? selectedMonthObj.name : null;


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth1);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Find index of selected month for fiscalYearMonthsJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth1);
    this.previousMonthsCountJanDec1 = this.selectedMonth1; // Count from January


    this.fetchSalaryBuckets();
    this.fetchIncrementBuckets();
    // this.fetchVPAmountBuckets();
    this.getVPCurrentYearFrequeny();

  }

  previousMonthsCountAprilMarch1: any;
  previousMonthsCountAprilMarch2: any;
  previousMonthsCountAprilMarch3: any;
  previousMonthsCountAprilMarch4: any;
  previousMonthsCountAprilMarch5: any;
  previousMonthsCountAprilMarch6: any;

  previousMonthsCountJanDec1: any;
  previousMonthsCountJanDec2: any;
  previousMonthsCountJanDec3: any;
  previousMonthsCountJanDec4: any;
  previousMonthsCountJanDec5: any;
  previousMonthsCountJanDec6: any;


  onMonthChange(event: any, graphNo: string) {
    const selectedMonthKey = event.value;

    let selectedMonthName = '';
    let prevCountApril = 0;
    let prevCountJan = 0;

    const selectedMonthObj = this.fiscalYearMonthsJanDec.find(m => m.key === selectedMonthKey);
    selectedMonthName = selectedMonthObj ? selectedMonthObj.name : '';


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey);
    prevCountApril = indexAprilMarch + 1;

    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === selectedMonthKey);
    prevCountJan = selectedMonthKey;

    switch (graphNo) {
      case 'first':
        this.selectedMonth1 = selectedMonthKey;
        this.selectedMonthName1 = selectedMonthName;
        this.previousMonthsCountAprilMarch1 = prevCountApril;
        this.previousMonthsCountJanDec1 = prevCountJan;
        this.fetchSalaryBuckets();

        // this.fetchPmsScoreData();
        break;

      case 'second':
        this.selectedMonth2 = selectedMonthKey;
        this.selectedMonthName2 = selectedMonthName;
        this.previousMonthsCountAprilMarch2 = prevCountApril;
        this.previousMonthsCountJanDec2 = prevCountJan;
        // this.fetchPotentialBuckets();
        break;

      case 'three':
        this.selectedMonth3 = selectedMonthKey;
        this.selectedMonthName3 = selectedMonthName;
        this.previousMonthsCountAprilMarch3 = prevCountApril;
        this.previousMonthsCountJanDec3 = prevCountJan;
        this.fetchIncrementBuckets();

        break;

      case 'four':
        this.selectedMonth4 = selectedMonthKey;
        this.selectedMonthName4 = selectedMonthName;
        this.previousMonthsCountAprilMarch4 = prevCountApril;
        this.previousMonthsCountJanDec4 = prevCountJan;
        this.getVPCurrentYearFrequeny();
        break;

      case 'five':
        this.selectedMonth5 = selectedMonthKey;
        this.selectedMonthName5 = selectedMonthName;
        this.previousMonthsCountAprilMarch5 = prevCountApril;
        this.previousMonthsCountJanDec5 = prevCountJan;

        break;
      case 'six':
        this.selectedMonth6 = selectedMonthKey;
        this.selectedMonthName6 = selectedMonthName;
        this.previousMonthsCountAprilMarch6 = prevCountApril;
        this.previousMonthsCountJanDec6 = prevCountJan;

        break;
      default:
        break;
    }
  }
  onMonthChange1(event: any) {
    const selectedMonthKey = event.value;
    this.selectedMonth = selectedMonthKey;

    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Find index of selected month for fiscalYearMonthsJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January

    this.fetchSalaryBuckets();

    this.fetchIncrementBuckets();
    // this.fetchVPAmountBuckets();
    this.getVPCurrentYearFrequeny();
  }

  fetchHODByUserList(graphNo: string) {
    let selectedYear: string;

    switch (graphNo) {
      case 'first':
        selectedYear = this.selectedYearForCompetency1;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'second':
        selectedYear = this.selectedYearForCompetency2;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'three':
        selectedYear = this.selectedYearForCompetency3;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'four':
        selectedYear = this.selectedYearForCompetency4;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'five':
        selectedYear = this.selectedYearForCompetency5;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'six':
        selectedYear = this.selectedYearForCompetency6;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      default:
        ['first', 'second', 'three', 'four', 'five', 'six'].forEach(gNo => {
          this.getMonths(this.fromYear, this.toYear, gNo);
        });
        selectedYear = this.selectedYearForCompetency1;


    }

    let apiUrl = `${this.config.fetchHODByUserList}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(apiUrl).subscribe((resp: any) => {
      this.arrUserIds = [];
      const arrHODByUserList = resp?.data?.data?.filter((emp: any) => emp?.userId != this.loggedInUserId);
      this.arrHODByUserList = arrHODByUserList;
      arrHODByUserList?.map((emp: any) => this.arrUserIds.push(emp?.userId));

      // this.getMonths(this.fromYear, this.toYear);
      if (this.loggedInUserRole == 'HOD') {
        // this.fetchKpiScoresForUsers(this.arrUserIds.map(String));
      }
    });

    let url = `${this.config.getEmployeeUnderHodExit}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(url).subscribe((resp: any) => {
      const arrHODByUserList = resp?.data?.data?.filter((emp: any) => emp?.userId != this.loggedInUserId);
      this.arrHODByExitedUserList = arrHODByUserList;
      arrHODByUserList?.map((emp: any) => this.arrExitedUserIds?.push(emp?.userId));
      // this.fetchNineBoxAttrition();
    });
  }

  getFrequency() {
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((response: any) => {
      this.setupFrequency = response.data['reviewCycle'] ? response.data['reviewCycle'] : response.data['yearRanges'];
      this.filterFrequencies()
    })
  }
  getFrequencies(): void {
    this.httpService.callGetService(
      `${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        if (data?.data) {
          const reviewCycle = data.data['reviewCycle'];
          const yearRanges = data.data['yearRanges'];
          this.setupFrequency = reviewCycle ? reviewCycle : yearRanges;

          this.getFrequencyForInput();
          this.filterFrequencies();
        } else {
          console.error('Get frequency response is null or invalid:', data);
          this.setupFrequency = null;
        }
      },
      error: (err) => {
        console.error('Error fetching :', err);
      }
    });
  }

  variablePeriodFrquency: any[] = [];
  getFrequencyForInput() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      console.log("+++++++++++++++++++++++++++++++", response)
      this.variablePeriodFrquency = response.data;

      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.setupFrequency == 'Monthly') {
        this.variablePeriodFrquency?.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
          }
        });
      }

      if (this.setupFrequency == 'Quarterly' || this.setupFrequency == 'Semi_Annually' || this.setupFrequency == 'Semi-Annually'
        || this.setupFrequency == 'Annually'
      ) {
        for (let range of this.variablePeriodFrquency) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
      }

      // this.filterMonthsForInput(this.setupFrequency);
    });

  }
  filterFrequencyVariable() {
    switch (this.variableFrequency) {
      case 'Monthly':
        this.filteredFrequenciesVariable = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Quarterly':
        this.filteredFrequenciesVariable = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequenciesVariable = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequenciesVariable = ["Annually"];
        break;
      default:
        this.filteredFrequenciesVariable = this.frequencies;
    }
  }

  getFrequencyForVariable() {
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((response: any) => {
      if (response?.data == null) {

      } else {
        this.variableFrequency = response?.data['reviewCycle'];
        this.filterFrequencyVariable();
      }
    })
  }
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  getVPCurrentYearFrequeny() {
    this.httpService.callGetService(this.config.getVPCurrentYearFrequeny + this.loggedInUserCompanyID + '/' +
      this.fromYear + '/' + this.toYear
    ).subscribe((result: any) => {
      console.log("+++++++++++++++++++", result);
      if (this.isSelectedYearIsSameYeartoCurrentYear) {
        if (result?.data == null) {
          this.isVPSetupDone = false;
        } else {
          if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
            this.isVPSetupDone = false;
          } else {
            this.isVPSetupDone = true;
          }
        }
      } else {
        this.isVPSetupDone = true;
      }
      if (result?.data == null) {
        this.isVPInputSetupNotDone = true;
        this.getFrequencies();
      } else {
        this.setupFrequency = result?.data;
        this.getFrequencyForInput();
        this.filterFrequencies()
        this.isVPInputSetupNotDone = false;
      }
    });
  }

  filterFrequencies() {
    // Call the get months API from Here and store the result into the setupFrequency
    switch (this.setupFrequency) {
      case 'Monthly':
        this.filteredFrequencies = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Quarterly':
        this.filteredFrequencies = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequencies = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequencies = ["Annually"];
        break;
      default:
        this.filteredFrequencies = this.frequencies;
    }

    this.updatePeriodOptions(this.setupFrequency);
    return of(this.filteredFrequencies);
  }

  updatePeriodOptions(event: any): void {
    let period = this.setupFrequency;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = this.setupFrequency;
    this.httpService.callGetService(
      `${this.config.getVariablePayMonths}/${this.loggedInUserCompanyID}/${period}`
    ).subscribe((response: any) => {
      this.setupMonths = response.data['months'];
      console.log(response);

      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.frequencyName == 'Monthly') {
        this.setupMonths.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
            console.log(this.frequencyPeriod)
          }
        });
      }

      if (this.frequencyName == 'Quarterly' || this.frequencyName == 'Semi_Annually' || this.frequencyName == 'Semi-Annually'
        || this.frequencyName == 'Annually'
      ) {
        for (let range of this.setupMonths) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
        console.error("++++++++++++++++++++++++++++++", this.frequencyPeriod)
        this.fetchVPAmountBuckets();
      }
    });

  }
  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }
  clearCutOffDays() {
    this.cutOffDays = null; // Clear the input box
    this.GetOverallIncrementBudgetGridData = [];
    this.fromMonth = null;
    this.cutOffDate = null;

  }
  onPeriodChange(event: any) {

    const selectedPeriod = this.frequencyPeriod;
    // Ensure event and value are not undefined

    // Check if selectedPeriod is valid (not undefined or null)
    if (!selectedPeriod) {
      this.selectedMonths = [];
      // this.frequencyPeriod = null;
      this.cutOffDate = null;
      this.cutOffDateForVariablepay = 'Invalid day';
      console.error('Selected period is undefined or null:', selectedPeriod);

      return; // Return an empty observable or handle the error case here

    }

    // If the period is multi-month (e.g., "January-March")
    if (this.frequencyName === 'Quarterly') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);  // Get the months between the period
        if (this.selectedMonths.length > 0) {
          // Calculate the next 3 months after the selected period
          const nextThreeMonths = this.getNextThreeMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set the From and To months to the next three months
          this.fromMonth = nextThreeMonths[0];
          this.toMonth = nextThreeMonths[nextThreeMonths.length - 1];
          this.getMonthsToVariablePay = nextThreeMonths;
        }
      }
    }
    else if (this.frequencyName === 'Monthly') {

      const monthResult = this.getNextMonth(selectedPeriod);
      this.selectedMonth = monthResult.next;  // This will give you the next month
      this.selectedMonths = [selectedPeriod];

      // Get the next 12 months starting from the month after the selected month
      this.getMonthsToVariablePay = [this.selectedMonth];

      this.fromMonth = this.getMonthsToVariablePay[0];
      this.toMonth = this.getMonthsToVariablePay[0];

    }
    else if (this.frequencyName === 'Semi-Annually') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);
        if (this.selectedMonths.length > 0) {
          const nextSixMonths = this.getNextSixMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set From and To months for the next six months
          this.fromMonth = nextSixMonths[0];
          this.toMonth = nextSixMonths[nextSixMonths.length - 1];
          this.getMonthsToVariablePay = nextSixMonths;
        }
      }
    }
    else if (this.frequencyName === 'Annually') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);  // Get the months between the period
        if (this.selectedMonths.length > 0) {
          // Calculate the next 3 months after the selected period
          const nextSixMonths = this.getAnnuallyMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set the From and To months to the next three months
          this.fromMonth = nextSixMonths[0];
          this.toMonth = nextSixMonths[nextSixMonths.length - 1];
          this.getMonthsToVariablePay = nextSixMonths;
        }
      }
    }
    this.onFromMonthChange();
    this.clearCutOffDays();
    this.fetchVPAmountBuckets();

    return of(this.getMonthsToVariablePay);
  }
  getPrevYearSetupVP() {
    const test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.prev_setupsOfVP + this.loggedInUserCompanyID + '/' +
      this.setupFrequency + '/' + test[0] + '/' + test[1] + '/' + this.frequencyPeriod).subscribe((result: any) => {

        this.previousOverallVPBudgetGrid = [];
        if (result.data?.length != 0) {
          for (let i = 0; i < result?.data?.length; i++) {
            this.previousOverallVPBudgetGrid.push({
              year: result?.data[i]?.fromYear + '-' + result?.data[i]?.toYear,
              frequencyPeriod: result?.data[i]?.frequency,
              frequencyCycle: result?.data[i]?.frequencyCycle,
              noOfEligibleEmployees: result?.data[i]?.noOfEligibleEmployees ?? 0,
              totalCtcOfEligibleEmployees: result?.data[i]?.totalCtcOfEligibleEmployees ?? 0,
              finalVPPercentage: result?.data[i]?.finalVPPercentage ? result?.data[i]?.finalVPPercentage : null,
              finalVPAmount: result?.data[i]?.finalVPAmount ? result?.data[i]?.finalVPAmount : null,
              isNew: false
            });
          }
        } else {
          this.previousOverallVPBudgetGrid = [];
        }
      });
  }

  // Helper function to get the next three months after the last month in the selected period
  getNextThreeMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next three months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 3; i++) {
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);  // Handle wrap-around using modulo
    }

    return nextMonths;
  }

  getNextSixMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next three months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 6; i++) {
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);  // Handle wrap-around using modulo
    }

    return nextMonths;
  }


  getAnnuallyMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next 12 months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 12; i++) {  // Adjusted to get 12 months
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);
    }

    return nextMonths;
  }


  // Function to get the next single month
  getNextMonth(currentMonth: string): { current: string, next: string } {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'
    ];

    const currentIndex = allMonths.indexOf(currentMonth);
    if (currentIndex === -1) return { current: currentMonth, next: currentMonth }; // If invalid month, return it as is

    const nextIndex = (currentIndex + 1) % allMonths.length; // Wrap around to the start if December is selected
    return { current: currentMonth, next: allMonths[nextIndex] };
  }

  getNextTwelveMonths(startIndex: number): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const nextTwelveMonths = [];

    for (let i = 0; i < 12; i++) {
      nextTwelveMonths.push(allMonths[(startIndex + i) % 12]); // Handle wrap-around using modulo
    }

    return nextTwelveMonths;

  }

  getMonthsBetween(selectedPeriod: string): string[] {
    const [startMonth, endMonth] = selectedPeriod.split('-');
    const startIndex = this.allMonths.indexOf(startMonth);
    const endIndex = this.allMonths.indexOf(endMonth);

    if (startIndex === -1 || endIndex === -1) {
      console.error('Invalid month range.');
      return [];
    }

    // Check if the range wraps around the year (e.g., October-March)
    if (startIndex <= endIndex) {
      // No wrap-around, return months within the same year
      return this.allMonths.slice(startIndex, endIndex + 1);
    } else {
      // Wrap-around case, combine months from the end of the year and the start of the year
      return [...this.allMonths.slice(startIndex), ...this.allMonths.slice(0, endIndex + 1)];
    }
  }
  onFromMonthChange() {
    const startIndex = this.getMonthsToVariablePay.indexOf(this.fromMonth);

    if (startIndex !== -1) {
      // Include the "From Month" in the available "To Month" options
      this.toMonthsVariablePay = this.getMonthsToVariablePay.slice(startIndex);
    } else {
      this.toMonthsVariablePay = [];
    }
    this.clearCutOffDays();
    this.fetchVPAmountBuckets();

  }
  processCutoffDateInput(day: string): void {
    const parsedDay = parseInt(day, 10);
    if (parsedDay && parsedDay > 0) {
      this.cutOffDays = parsedDay; // Update cutOffDays

      // Convert parsedDay back to a string for calculateCutoffDate
      this.calculateCutoffDate(parsedDay.toString());
      // Trigger the API call
      // this.getCutOffDataForApi();
    } else {
      console.warn('Invalid cutoff day input. API call not triggered.');
    }
  }

  calculateCutoffDate(day: string): void {
    const dayNumber = parseInt(day, 10);
    if (this.frequencyName === 'Monthly') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 30) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Quarterly') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 90) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Semi-Annually') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 180) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Annually') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 365) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }

    if (this.selectedMonths.length > 0) {
      const monthDays: { [key: string]: number } = {
        'January': 31,
        'February': this.isLeapYear(new Date().getFullYear()) ? 29 : 28,
        'March': 31,
        'April': 30,
        'May': 31,
        'June': 30,
        'July': 31,
        'August': 31,
        'September': 30,
        'October': 31,
        'November': 30,
        'December': 31
      };

      const firstMonth = this.selectedMonths[0];
      let currentYear = new Date().getFullYear(); // Use the current year
      let currentMonth = firstMonth;
      let remainingDays = dayNumber;
      let calculatedDay = 0;

      // Helper to get the next month
      const getNextMonth = (current: string): string => {
        const months = Object.keys(monthDays);
        const currentIndex = months.indexOf(current);
        return months[(currentIndex + 1) % 12]; // Cycle through months
      };

      // Loop through the months and subtract the days
      while (remainingDays > 0) {
        const daysInCurrentMonth = monthDays[currentMonth];
        if (remainingDays <= daysInCurrentMonth) {
          calculatedDay = remainingDays; // Final cutoff day within the current month
          break;
        } else {
          remainingDays -= daysInCurrentMonth; // Move to next month
          currentMonth = getNextMonth(currentMonth); // Get next month

          // Check if we need to increment the year
          if (currentMonth === 'January') {
            currentYear++; // Increment the year when we reach January
          }
        }
      }

      // Format the month number and the date
      const formattedMonth = this.formatMonthToNumber(currentMonth as 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December');
      this.cutOffDateForVariablepay = `${calculatedDay.toString().padStart(2, '0')}/${formattedMonth}/${currentYear}`;
    }
    this.employeeCountOnDateChange();
  }
  employeeCountOnDateChange() {
    const cutOffDate = this.datePipe.transform(this.cutOffDateForVariablepay, "yyyy-MM-dd");
    this.httpService.callGetService(this.config.empcount_ctc + this.loggedInUserCompanyID + '/' + cutOffDate + '/' + this.setupFrequency).subscribe((result: any) => {

    });
  }
  // Helper function to check for leap year
  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  // Helper function to format month names into numbers
  formatMonthToNumber(month: 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December'): string {
    const months = {
      'January': '01', 'February': '02', 'March': '03', 'April': '04',
      'May': '05', 'June': '06', 'July': '07', 'August': '08',
      'September': '09', 'October': '10', 'November': '11', 'December': '12'
    };
    return months[month]; // TypeScript now knows that 'month' will be a valid key
  }

  selectGraphType: any = 'bar';
  selectedFromDated: any;
  selectedtoDated: any;
  taskFromDate: any;
  taskToDate: any;

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }

  downloadChartAsPDF(type: string, graphNo: string): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

    const idMapping: { [key: string]: string } = {
      'Salary Range Attrition': this.isSalaryRangeTable ? 'table-Salary-Range-data' : 'salary-range-chart',
      'Increment Attrition': this.isIncrementRateTable ? 'table-Increment-Attrition-data' : 'increment-chart',
      'VP Amount': this.isVPAmountTable ? 'table-VP-Amount-data' : 'vpamount-chart',
    };

    const yearMap: { [key: string]: string } = {
      first: this.selectedYearForCompetency1,
      second: this.selectedYearForCompetency2,
      three: this.selectedYearForCompetency3,
      four: this.selectedYearForCompetency4,
      five: this.selectedYearForCompetency5,
      six: this.selectedYearForCompetency6
    };

    const monthMap: { [key: string]: string } = {
      first: this.selectedMonthName1,
      second: this.selectedMonthName2,
      three: this.selectedMonthName3,
      four: this.selectedMonthName4,
      five: this.selectedMonthName5,
      six: this.selectedMonthName6
    };

    const idSelector = idMapping[type] || 'default-chart-id';

    const selectedYearRaw = yearMap[graphNo] || this.selectedYearForCompetency1;
    const selectedMonthRaw = monthMap[graphNo] || this.selectedMonthName1;

    const selectedYear = this.loggedInCompanyFiscalyear === 'Jan_Dec'
    ? `FY ${selectedYearRaw.split('-')[0]}`
    : `FY ${selectedYearRaw.split('-')[0]}-${selectedYearRaw.split('-')[1]?.slice(-2)}`;

    // const normalizedType = type.trim().toLowerCase();
    // const excludedTypes = ['increment attrition', 'vp amount'];
    // const month = excludedTypes.includes(normalizedType) && normalizedType !== 'vp amount' ? '' : selectedMonthRaw;

    // const frequency = normalizedType === 'vp amount' ? (this.frequencyPeriod || '') : '';
    const normalizedType = type.trim().toLowerCase();
    const showMonth = normalizedType !== 'increment attrition' && normalizedType !== 'vp amount';
    const month = showMonth ? selectedMonthRaw : '';
    const frequency = normalizedType === 'vp amount' ? (this.frequencyPeriod || '') : '';

    this.PdfDownload.downloadPDFMonthwise(
      idSelector,
      type,
      selectedYear,
      month,
      frequency
    );
  }

  // --------------------------Salary Range-----------------------------
  public isSalaryRangeChartIcon: string = 'bar';
  public isSalaryRangeTable: boolean = false;
  public isSalaryRangeTableGraph: any[] = [];
  public selectGraphSalaryRangeType: any = 'bar';
  public salaryRangeData: any;
  public salaryBuckets: any;
  fetchSalaryBuckets(): void {
    this.httpService.callGetService(`${this.config.salaryBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency1}`)
      .subscribe({
        next: (data: any) => {
          this.salaryBuckets = data.data;
          console.log('salaryBuckets', this.salaryBuckets);
          this.fetchSalaryRange();

        },
        error: (err) => {
          console.error('Error fetching salary buckets:', err);
        }
      });
  }
  fetchSalaryRange(): void {

    const month = this.selectedMonth1 || (new Date().getMonth() + 1);
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    console.log("userHodExitedIdsString", userHodExitedIdsString);

    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {

      this.salaryRangeGraph('bar');
      return;
    }
    const apiUrl = (userHodExitedIdsString) ? `${this.config.salaryRangeDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency1}&month=${month}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}` :
      `${this.config.salaryRangeDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency1}&month=${month}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.salaryRangeData = data;
          console.log('Salary Range Data:', this.salaryRangeData);
          this.salaryRangeGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching salary range data:', err);
        }
      });
  }

  salaryRangeChart(graphType: any) {
    this.selectGraphSalaryRangeType = graphType;
    this.isSalaryRangeChartIcon = graphType;
    this.isSalaryRangeTable = false;
    this.salaryRangeGraph(this.selectGraphSalaryRangeType);
  }

  salaryRangeChartTable() {
    this.selectGraphSalaryRangeType = 'table';
    this.isSalaryRangeChartIcon = '';
    this.isSalaryRangeTable = true;
  }

  salaryRangeLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  salaryRangeBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  salaryRangeGraph(graphType: string): void {
    console.log("Salary Range Data:", this.salaryRangeData);

    if (!this.salaryRangeData?.data?.length || !this.salaryBuckets?.length) {
      console.warn("Data Not Found: Salary Range data or Buckets are missing");
      this.isSalaryRangeTableGraph = [];
      const chartElement = document.getElementById('salary-range-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const salaryData = this.salaryRangeData.data[0];
    const exitUsers = salaryData.AllExitUser || [];
    const activeUsers = salaryData.AllActiveUsers?.filter((u: any) => u.SalaryRange !== null) || [];

    const month = this.selectedMonth1 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);

    const extendedBuckets = [...this.salaryBuckets];
    const lastBucket = this.salaryBuckets[this.salaryBuckets.length - 1];
    extendedBuckets.push({
      lowerEnd: lastBucket.upperEnd,
      upperEnd: Number.MAX_SAFE_INTEGER
    });

    const bucketData = extendedBuckets.map((bucket, index) => {
      const isLast = index === extendedBuckets.length - 1;
      const range = isLast ? `${bucket.lowerEnd}+` : `${bucket.lowerEnd}-${bucket.upperEnd}`;

      let exitCount = 0;
      let activeCount = 0;

      exitUsers.forEach((user: any) => {
        const salary = +user.SalaryRange;
        if (salary >= bucket.lowerEnd && salary < bucket.upperEnd) {
          exitCount++;
        }
      });

      activeUsers.forEach((user: any) => {
        const salary = +user.SalaryRange;
        if (salary >= bucket.lowerEnd && salary < bucket.upperEnd) {
          activeCount++;
        }
      });

      const totalUsers = exitCount + activeCount;

      const attritionPercentage = totalUsers > 0
        ? ((exitCount / totalUsers) * 100).toFixed(2)
        : '0.00';

      const annualizedAttrition = ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2);

      return graphType === 'pie'
        ? {
          name: range,
          value: exitCount,
          attritionPercentage,
          annualizedAttrition
        }
        : {
          xAxisValueData: range,
          seriesValueOneData: exitCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'Salary Range',
          yAxisName: 'Employee Count',
          seriesLabelOne: 'Exit Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
    });

    console.log("Transformed Salary Range Data:", bucketData);
    this.isSalaryRangeTableGraph = bucketData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(bucketData);
      echarts.init(document.getElementById('salary-range-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Salary Ranges',
        yAxisName: 'Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.salaryRangeBarGraph,
        line: this.salaryRangeLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, bucketData, 'salary-range-chart', 'single', seriesLabels);
      }
    }
  }

  //-----------------Increment----------------------
  public isIncrementRateTable: boolean = false;
  public isIncrementTableGraph: any[] = [];
  public selectGraphIncrementType: any = 'bar';
  public incrementData: any;
  public incrementBuckets: any;
  public isIncrementRateIcon: string = 'bar';

  incrementRate(graphType: any) {
    this.selectGraphIncrementType = graphType;
    this.isIncrementRateIcon = graphType;
    this.isIncrementRateTable = false;
    this.incrementGraph(this.selectGraphIncrementType);
  }

  incrementRateTable() {
    this.selectGraphIncrementType = 'table';
    this.isIncrementRateIcon = '';
    this.isIncrementRateTable = true;
  }

  incrementBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  incrementLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  fetchIncrementBuckets(): void {

    this.httpService.callGetService(`${this.config.incrementBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency3}`)
      .subscribe({
        next: (data: any) => {
          this.incrementBuckets = data.data;
          console.log('incrementBuckets', this.incrementBuckets);
          this.fetchIncrementData();
        },
        error: (err) => {
          console.error('Error fetching increment buckets:', err);
        }
      });
  }

  fetchIncrementData(): void {
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    console.log("userHodExitedIdsString", userHodExitedIdsString);

    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {

      this.incrementGraph('bar');
      return;
    }
    const apiUrl = (userHodExitedIdsString) ? `${this.config.incrementDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency3}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}` :
      `${this.config.incrementDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency3}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.incrementData = data;
          console.log('Increment Data:', this.incrementData);
          this.incrementGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching increment data:', err);
        }
      });
  }

  incrementGraph(graphType: string): void {
    console.log("Increment Data:", this.incrementData);

    if (!this.incrementData?.data?.length || !this.incrementBuckets?.length) {
      console.warn("Data Not Found: Increment data or Increment Buckets are missing");
      this.isIncrementTableGraph = [];
      const chartElement = document.getElementById('increment-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const previousMonthsCount = this.loggedInCompanyFiscalyear === "Jan_Dec"
      ? this.previousMonthsCountJanDec
      : this.previousMonthsCountAprilMarch;

    const allExitUsers = this.incrementData.data[0]?.AllExitUser || [];
    const allActiveUsers = this.incrementData.data[0]?.AllActiveUsers || [];

    const allUsers = [...allExitUsers, ...allActiveUsers].filter(u => u.Increment !== null);

    const extendedBuckets = [...this.incrementBuckets];
    const lastBucket = this.incrementBuckets[this.incrementBuckets.length - 1];
    extendedBuckets.push({
      lowerEnd: lastBucket.upperEnd,
      upperEnd: Number.MAX_SAFE_INTEGER
    });

    const bucketData = extendedBuckets.map((bucket, index) => {
      const isLast = index === extendedBuckets.length - 1;
      const range = isLast ? `${bucket.lowerEnd}+` : `${bucket.lowerEnd}-${bucket.upperEnd}`;

      const exitCount = allExitUsers.filter((u: any) => u.Increment >= bucket.lowerEnd && u.Increment < bucket.upperEnd).length;
      const activeCount = allActiveUsers.filter((u: any) => u.Increment >= bucket.lowerEnd && u.Increment < bucket.upperEnd).length;
      const total = exitCount + activeCount;

      const attritionPercentage = total > 0
        ? ((exitCount / total) * 100).toFixed(2)
        : '0.00';

      const annualizedAttrition = ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2);

      return graphType === 'pie'
        ? {
          name: range,
          value: exitCount,
          attritionPercentage,
          annualizedAttrition
        }
        : {
          xAxisValueData: range,
          seriesValueOneData: exitCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'Increment %',
          yAxisName: 'Attrition Count',
          seriesLabelOne: 'Attrition Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
    });

    console.log("Transformed Increment Data:", bucketData);
    this.isIncrementTableGraph = bucketData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(bucketData);
      echarts.init(document.getElementById('increment-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Increment Buckets',
        yAxisName: 'Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.incrementBarGraph,
        line: this.incrementLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, bucketData, 'increment-chart', 'single', seriesLabels);
      }
    }
  }

  //-----------------VP Amount----------------------
  public isVPAmountTable: boolean = false;
  public isVPAmountTableGraph: any[] = [];
  public selectGraphVPAmountType: any = 'bar';
  public vpAmountData: any;
  public vpAmountBuckets: any;
  public isVPAmountIcon: string = 'bar';

  vpAmountRate(graphType: any) {
    this.selectGraphVPAmountType = graphType;
    this.isVPAmountIcon = graphType;
    this.isVPAmountTable = false;
    this.vpAmountGraph(this.selectGraphVPAmountType);
  }

  vpAmountRateTable() {
    this.selectGraphVPAmountType = 'table';
    this.isVPAmountIcon = '';
    this.isVPAmountTable = true;
  }

  fetchVPAmountBuckets(): void {
    this.httpService.callGetService(`${this.config.vpAmountBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency4}`)
      .subscribe({
        next: (data: any) => {
          this.vpAmountBuckets = data.data;
          console.log('VP Amount Buckets:', this.vpAmountBuckets);
          this.fetchVPAmountData(this.frequencyPeriod);
        },
        error: (err) => {
          console.error('Error fetching VP Amount buckets:', err);
        }
      });
  }

  fetchVPAmountData(selectedPeriod: string): void {
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    console.log("userHodExitedIdsString", userHodExitedIdsString);

    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {

      this.incrementGraph('bar');
      return;
    }
    const apiUrl = (userHodExitedIdsString) ? `${this.config.vpAmountDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency4}&frequencyCycle=${selectedPeriod}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}`
      : `${this.config.vpAmountDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency4}&frequencyCycle=${selectedPeriod}`
    console.warn(selectedPeriod);
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.vpAmountData = data;
          console.log('VP Amount Data:', this.vpAmountData);
          this.vpAmountGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching VP Amount data:', err);
        }
      });
  }
  vpAmountGraph(graphType: string): void {
    console.log('VP Amount Data:', this.vpAmountData);

    if (!this.vpAmountData?.data?.length || !this.vpAmountBuckets?.length) {
      console.warn('Data Not Found: VP Amount data or VP Amount Buckets are missing');
      this.isVPAmountTableGraph = [];
      const chartElement = document.getElementById('vpamount-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const allExitMap = new Map<number, number>();
    const allActiveMap = new Map<number, number>();

    const users = this.vpAmountData.data[0];

    users.AllExitUser.forEach((user: any) => {
      const id = user.User_id;
      const amount = +user.VpAmount;
      allExitMap.set(id, (allExitMap.get(id) || 0) + amount);
    });

    users.AllActiveUsers.forEach((user: any) => {
      const id = user.User_id;
      const amount = +user.VpAmount;
      allActiveMap.set(id, (allActiveMap.get(id) || 0) + amount);
    });

    const combinedUsers = new Map<number, { VpAmount: number; isExit: boolean }>();

    allExitMap.forEach((amount, id) => {
      combinedUsers.set(id, { VpAmount: amount, isExit: true });
    });

    allActiveMap.forEach((amount, id) => {
      if (combinedUsers.has(id)) {
        combinedUsers.set(id, {
          VpAmount: combinedUsers.get(id)!.VpAmount + amount,
          isExit: true, // Treat as exit if appears in both
        });
      } else {
        combinedUsers.set(id, { VpAmount: amount, isExit: false });
      }
    });

    const extendedBuckets = [...this.vpAmountBuckets];
    const lastBucket = this.vpAmountBuckets[this.vpAmountBuckets.length - 1];
    extendedBuckets.push({
      lowerEnd: lastBucket.upperEnd,
      upperEnd: Number.MAX_SAFE_INTEGER
    });

    const transformedData = extendedBuckets.map((bucket, index) => {
      const isLast = index === extendedBuckets.length - 1;
      const range = isLast ? `${bucket.lowerEnd}+` : `${bucket.lowerEnd}-${bucket.upperEnd}`;

      let activeCount = 0;
      let exitCount = 0;

      combinedUsers.forEach(user => {
        const amt = user.VpAmount;
        if (amt >= bucket.lowerEnd && amt < bucket.upperEnd) {
          user.isExit ? exitCount++ : activeCount++;
        }
      });
      console.log(activeCount, exitCount);

      const total = activeCount + exitCount;
      const attritionPercentage = total > 0 ? ((exitCount / total) * 100).toFixed(2) : '0.00';

      return graphType === 'pie'
        ? {
          name: range,
          value: exitCount,
          attritionPercentage
        }
        : {
          xAxisValueData: range,
          seriesValueOneData: exitCount,
          seriesValueTwoData: +attritionPercentage,
          xAxisName: 'VP Amount Buckets',
          yAxisName: 'Attrition Count',
          seriesLabelOne: 'Exit Count',
          seriesLabelTwo: 'Attrition %'
        };
    });

    console.log('Transformed VP Amount Data:', transformedData);
    this.isVPAmountTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('vpamount-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'VP Amount Buckets',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.incrementBarGraph,
        line: this.incrementLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'vpamount-chart', 'single', seriesLabels);
      }
    }
  }


  attritionPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          // console.log(params);

          // Extract all available data dynamically
          let tooltipContent = `<strong>${params.name}</strong><br/>`;
          Object.keys(params.data).forEach((key) => {
            if (key !== 'name' && key !== 'value') {
              const formattedKey = key.replace(/([A-Z])/g, ' $1').trim(); // Convert camelCase to spaced words
              tooltipContent += `${formattedKey}: <strong>${params.data[key]}</strong><br/>`;
            }
          });

          return tooltipContent;
        }
      },
      legend: {
        bottom: 0
      },
      color: [
        '#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#FAC858',
        '#9A60B4', '#EA7CCC', '#3BA${this.loggedInUserCompanyID}', '#FC8452', '#B4A7D6'
      ],
      series: [
        {
          name: 'Department',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: (params: any) => {
              return `${params.name}: ${params.value}`; // Dynamic label with department & count
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: data
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }



}
